import React from 'react';
import styles from './PinField.css';

class PinField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <span className={styles['pin-text']}>
          {this.state.showPassword ? this.props.pin : '••••'}
        </span>
        <i
          type="button"
          onClick={this._showPasswordButton}
          className={`${styles['eye-button']} ${
            this.state.showPassword
              ? 'glyphicon glyphicon-eye-close'
              : 'glyphicon glyphicon-eye-open'
          }`}
        />
      </div>
    );
  }

  _showPasswordButton = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };
}

export default PinField;
